module.exports = __webpack_public_path__ + "img/insta.50367803.svg";